var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "currentSchedule" } },
    [
      !!_vm.dates.MIN_DATE
        ? _c("time-traveller", {
            attrs: {
              dateOptions: _vm.dates,
              expandedDate: _vm.getExpandedDate()
            },
            on: { timeTravel: _vm.refreshSchedule }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("section", { staticClass: "toggle-bar hidden-print row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-md-6 col-lg-3 bold" },
          [
            _c("toggle-button", {
              attrs: {
                "css-colors": true,
                label: _vm.$t(
                  "MAIN_CONTENT.CurrentSchedule.showCourseSectionTitleCase"
                ),
                ariaLabel: _vm.$t(
                  "MAIN_CONTENT.CurrentSchedule.showCourseSectionTitleCase"
                ),
                showInFront: false
              },
              model: {
                value: _vm.scheduleOptions.showCourseSections,
                callback: function($$v) {
                  _vm.$set(_vm.scheduleOptions, "showCourseSections", $$v)
                },
                expression: "scheduleOptions.showCourseSections"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-md-6 col-lg-2 bold" },
          [
            _c("toggle-button", {
              attrs: {
                "css-colors": true,
                label: _vm.$t(
                  "MAIN_CONTENT.CurrentSchedule.showColorTitleCase"
                ),
                ariaLabel: _vm.$t(
                  "MAIN_CONTENT.CurrentSchedule.showColorTitleCase"
                ),
                showInFront: false
              },
              model: {
                value: _vm.scheduleOptions.showColors,
                callback: function($$v) {
                  _vm.$set(_vm.scheduleOptions, "showColors", $$v)
                },
                expression: "scheduleOptions.showColors"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-md-6 col-lg-2 bold" },
          [
            _c("toggle-button", {
              attrs: {
                "css-colors": true,
                label: _vm.$t(
                  "MAIN_CONTENT.CurrentSchedule.showCourseTimesTitleCase"
                ),
                ariaLabel: _vm.$t(
                  "MAIN_CONTENT.CurrentSchedule.showCourseTimesTitleCase"
                ),
                showInFront: false
              },
              model: {
                value: _vm.scheduleOptions.showCourseTimes,
                callback: function($$v) {
                  _vm.$set(_vm.scheduleOptions, "showCourseTimes", $$v)
                },
                expression: "scheduleOptions.showCourseTimes"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.dataLoaded
        ? _c(
            "tabs",
            {
              attrs: {
                options: {
                  useUrlFragment: false,
                  defaultTabHash: _vm.selectedTab
                }
              }
            },
            _vm._l(_vm.formattedData.SCHOOLS, function(school, schoolIndex) {
              return _c(
                "tab",
                {
                  key: "school_" + schoolIndex,
                  attrs: {
                    name: school.SCHOOL_TITLE,
                    id: school.SCHOOL_ID,
                    tabindex: "0"
                  }
                },
                [
                  _c("section", { staticClass: "current-schedule" }, [
                    _c("div", { staticClass: "table-responsive" }, [
                      _c(
                        "table",
                        {
                          staticClass:
                            "table table-current-schedule usa-table usa-table--borderless"
                        },
                        [
                          _c("thead", [
                            _c(
                              "tr",
                              [
                                _c("th", {
                                  staticClass: "period-col",
                                  attrs: { scope: "col", tabindex: "0" }
                                }),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.formattedData.DAYS[school.SCHOOL_ID],
                                  function(day, dayIndex) {
                                    return _c(
                                      "th",
                                      {
                                        key: "day_header_" + dayIndex,
                                        staticClass: "day-head",
                                        attrs: { scope: "col", tabindex: "0" }
                                      },
                                      [
                                        _c(
                                          "abbr",
                                          _vm._l(day.CYCLE_DAYS, function(
                                            cycleDay
                                          ) {
                                            return _c(
                                              "div",
                                              { key: "CYCLE_DAYS_" + cycleDay },
                                              [
                                                _vm._v(
                                                  _vm._s(cycleDay.DAY_DESC)
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm._f("date")(
                                                  day.CALENDAR_DAY,
                                                  "MM-DD-YYYY",
                                                  null,
                                                  _vm.getSelectedLocale
                                                    .LOCALE_CODE
                                                )
                                              ) +
                                              " "
                                          ),
                                          _c("br"),
                                          _c("small", [
                                            _vm._v(
                                              "(" +
                                                _vm._s(
                                                  _vm._f("day")(
                                                    day.CALENDAR_DAY,
                                                    "MM-DD-YYYY"
                                                  )
                                                ) +
                                                ")"
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm._l(
                                _vm.formattedData.PERIODS[school.SCHOOL_ID],
                                function(per, periodIndex) {
                                  return [
                                    school.SCHOOL_ID.toString() ===
                                      per.SCHOOL_ID.toString() &&
                                    per.HIDE_ON_SCHEDULE_FLG === "N" &&
                                    _vm.hasCourses(
                                      school.SCHOOL_ID,
                                      "" + per.PERIOD_CODE
                                    )
                                      ? [
                                          _c(
                                            "tr",
                                            {
                                              key: "period_" + periodIndex,
                                              staticClass: "schedule-class",
                                              attrs: { scope: "row" }
                                            },
                                            [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "period-col",
                                                  attrs: { tabindex: "0" }
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          per.PERIOD_CODE
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.formattedData.DAYS[
                                                  school.SCHOOL_ID
                                                ],
                                                function(day, dayIndex) {
                                                  return [
                                                    _c(
                                                      "td",
                                                      {
                                                        key:
                                                          "school_" +
                                                          schoolIndex +
                                                          "_day_" +
                                                          dayIndex
                                                      },
                                                      [
                                                        _vm._l(
                                                          _vm.schedule[
                                                            school.SCHOOL_ID
                                                          ],
                                                          function(
                                                            sch,
                                                            scheduleIndex
                                                          ) {
                                                            return [
                                                              _vm.checkIfShow(
                                                                school,
                                                                sch,
                                                                per,
                                                                day
                                                              )
                                                                ? [
                                                                    _vm
                                                                      .scheduleOptions
                                                                      .showColors
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            key:
                                                                              "schedule_" +
                                                                              scheduleIndex +
                                                                              "_day_" +
                                                                              dayIndex,
                                                                            style:
                                                                              "background-color: #" +
                                                                              sch.COLOR_HEX +
                                                                              "; padding-left: 5px;",
                                                                            attrs: {
                                                                              tabindex:
                                                                                "0"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "class-head"
                                                                              },
                                                                              [
                                                                                _vm.showRole(
                                                                                  "GRADES_FLG"
                                                                                )
                                                                                  ? _c(
                                                                                      "router-link",
                                                                                      {
                                                                                        attrs: {
                                                                                          to: {
                                                                                            name:
                                                                                              "ClassPageHome",
                                                                                            params: {
                                                                                              courseSectionGUID:
                                                                                                sch.COURSE_SECTION_GUID
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "span",
                                                                                          [
                                                                                            _c(
                                                                                              "strong",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    sch.COURSE_TITLE
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _c(
                                                                                      "span",
                                                                                      [
                                                                                        _c(
                                                                                          "strong",
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                sch.COURSE_TITLE
                                                                                              )
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "class-body"
                                                                              },
                                                                              [
                                                                                _vm
                                                                                  .scheduleOptions
                                                                                  .showCourseSections
                                                                                  ? _c(
                                                                                      "div",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                            _vm._s(
                                                                                              sch.COURSE_ID
                                                                                            ) +
                                                                                            " - " +
                                                                                            _vm._s(
                                                                                              sch.SECTION_ID
                                                                                            ) +
                                                                                            " "
                                                                                        ),
                                                                                        _c(
                                                                                          "br"
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        sch.STAFF_NAME
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "RM " +
                                                                                        _vm._s(
                                                                                          sch.ROOM_CODE
                                                                                        ) +
                                                                                        " " +
                                                                                        _vm._s(
                                                                                          sch.DURATION_DESC
                                                                                        ) +
                                                                                        " " +
                                                                                        _vm._s(
                                                                                          sch.DAY_CODE
                                                                                        ) +
                                                                                        " "
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _vm
                                                                                  .scheduleOptions
                                                                                  .showCourseTimes
                                                                                  ? _c(
                                                                                      "div",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                            _vm._s(
                                                                                              _vm._f(
                                                                                                "time"
                                                                                              )(
                                                                                                sch.DETERMINED_START_TIME
                                                                                              )
                                                                                            ) +
                                                                                            " - " +
                                                                                            _vm._s(
                                                                                              _vm._f(
                                                                                                "time"
                                                                                              )(
                                                                                                sch.DETERMINED_END_TIME
                                                                                              )
                                                                                            ) +
                                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e()
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    !_vm
                                                                      .scheduleOptions
                                                                      .showColors
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            key:
                                                                              "schedule_" +
                                                                              scheduleIndex +
                                                                              "_day_" +
                                                                              dayIndex,
                                                                            staticStyle: {
                                                                              "padding-left":
                                                                                "5px"
                                                                            },
                                                                            attrs: {
                                                                              tabindex:
                                                                                "0"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "class-head"
                                                                              },
                                                                              [
                                                                                _vm.showRole(
                                                                                  "GRADES_FLG"
                                                                                )
                                                                                  ? _c(
                                                                                      "router-link",
                                                                                      {
                                                                                        attrs: {
                                                                                          to: {
                                                                                            name:
                                                                                              "ClassPageHome",
                                                                                            params: {
                                                                                              courseSectionGUID:
                                                                                                sch.COURSE_SECTION_GUID
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "span",
                                                                                          [
                                                                                            _c(
                                                                                              "strong",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    sch.COURSE_TITLE
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _c(
                                                                                      "span",
                                                                                      [
                                                                                        _c(
                                                                                          "strong",
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                sch.COURSE_TITLE
                                                                                              )
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "class-body"
                                                                              },
                                                                              [
                                                                                _vm
                                                                                  .scheduleOptions
                                                                                  .showCourseSections
                                                                                  ? _c(
                                                                                      "div",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                            _vm._s(
                                                                                              sch.COURSE_ID
                                                                                            ) +
                                                                                            " - " +
                                                                                            _vm._s(
                                                                                              sch.PERIOD_CODE
                                                                                            ) +
                                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        sch.STAFF_NAME
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "MAIN_CONTENT.CurrentSchedule.rm"
                                                                                        )
                                                                                      ) +
                                                                                        " " +
                                                                                        _vm._s(
                                                                                          sch.ROOM_CODE
                                                                                        ) +
                                                                                        " " +
                                                                                        _vm._s(
                                                                                          sch.DURATION_DESC
                                                                                        )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _vm
                                                                                  .scheduleOptions
                                                                                  .showCourseTimes
                                                                                  ? _c(
                                                                                      "div",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                            _vm._s(
                                                                                              _vm._f(
                                                                                                "time"
                                                                                              )(
                                                                                                sch.DETERMINED_START_TIME
                                                                                              )
                                                                                            ) +
                                                                                            " - " +
                                                                                            _vm._s(
                                                                                              _vm._f(
                                                                                                "time"
                                                                                              )(
                                                                                                sch.DETERMINED_END_TIME
                                                                                              )
                                                                                            ) +
                                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e()
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    _c("br", {
                                                                      key:
                                                                        "break_line_schedule_" +
                                                                        scheduleIndex +
                                                                        "_day_" +
                                                                        dayIndex
                                                                    })
                                                                  ]
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      : _vm._e()
                                  ]
                                }
                              )
                            ],
                            2
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }